// extracted by mini-css-extract-plugin
module.exports = {"mhGh5":"mhGh5_mhGh5__qC23x"};